var _rect, _g, _g2, _rect2, _g3, _g4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser01Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 326 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 326,
    height: 209,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 326,
    x: 326,
    fill: "#fff",
    rx: 28,
    transform: "rotate(90 326 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162.295,
    cy: -232.295,
    r: 414.705,
    fill: "url(#b)",
    transform: "rotate(90 162.295 -232.295)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234.83,
    height: 174.428,
    x: 45.584,
    y: 40,
    fill: "#fff",
    rx: 5.695
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.863,
    height: 9.863,
    x: 260.691,
    y: 46.78,
    fill: "#EAEAEA",
    rx: 4.931
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M270.021 59.723H115.847a7.088 7.088 0 0 1-7.088-7.088 8.321 8.321 0 0 0-8.321-8.32H61.3a8.32 8.32 0 0 0-8.321 8.32v3.39a3.698 3.698 0 0 1-3.698 3.698 1.85 1.85 0 0 0-1.85 1.85v141.55a8.542 8.542 0 0 0 8.532 8.542l214.047.286a8.543 8.543 0 0 0 8.554-8.543V68.266a8.543 8.543 0 0 0-8.543-8.543Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 11.711,
    x: 16,
    y: 208.88,
    fill: "#fff",
    rx: 5.695
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 50.541,
    height: 9.862,
    x: 55.445,
    y: 46.78,
    fill: "#111",
    rx: 4.931
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 69.649,
    height: 12.327,
    x: 55.445,
    y: 71.434,
    fill: "#fff",
    rx: 6.164
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 69.649,
    height: 12.327,
    x: 55.445,
    y: 115.195,
    fill: "#fff",
    rx: 6.164
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 69.649,
    height: 12.327,
    x: 55.445,
    y: 158.956,
    fill: "#fff",
    rx: 6.164
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 80.445,
    height: 4.983,
    x: 55.445,
    y: 131.22,
    fill: "#fff",
    rx: 2.492
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 116.752,
    height: 4.983,
    x: 55.445,
    y: 139.051,
    fill: "#fff",
    rx: 2.492
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 54.818,
    height: 4.983,
    x: 55.445,
    y: 146.882,
    fill: "#fff",
    rx: 2.492
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 80.445,
    height: 4.983,
    x: 55.445,
    y: 87.459,
    fill: "#fff",
    rx: 2.492
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 116.752,
    height: 4.983,
    x: 55.445,
    y: 95.29,
    fill: "#fff",
    rx: 2.492
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 54.818,
    height: 4.983,
    x: 55.445,
    y: 103.121,
    fill: "#fff",
    rx: 2.492
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 80.445,
    height: 4.983,
    x: 55.445,
    y: 174.981,
    fill: "#fff",
    rx: 2.492
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 116.752,
    height: 4.983,
    x: 55.445,
    y: 182.812,
    fill: "#fff",
    rx: 2.492
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 54.818,
    height: 4.983,
    x: 55.445,
    y: 190.643,
    fill: "#fff",
    rx: 2.492
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 38.832,
    height: 9.862,
    x: 219.396,
    y: 46.78,
    fill: "#EAEAEA",
    rx: 4.931
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 3.699,
    height: 3.699,
    x: 251.447,
    y: 49.862,
    fill: "#D8D8D8",
    rx: 1.849
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 52.391,
    height: 9.862,
    x: 164.543,
    y: 46.78,
    fill: "#EAEAEA",
    rx: 4.931
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3.699,
    height: 3.699,
    x: 210.152,
    y: 49.862,
    fill: "#D8D8D8",
    rx: 1.849
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 50.541,
    height: 9.862,
    x: 111.539,
    y: 46.78,
    fill: "#EAEAEA",
    rx: 4.931
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 3.699,
    height: 3.699,
    x: 154.684,
    y: 49.862,
    fill: "#D8D8D8",
    rx: 1.849
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 3.699,
    height: 3.699,
    x: 99.207,
    y: 49.862,
    fill: "#EAEAEA",
    rx: 1.849
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 263.306,
    height: 202.904,
    x: 31.346,
    y: 28.61,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.119
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 236.828,
    height: 173.332,
    x: 44.584,
    y: 41.467,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 322.476,
    height: 40.187,
    x: 1.762,
    y: 197.49,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.119
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -139.129,
    x2: 489.473,
    y1: -114.364,
    y2: -278.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 162.998,
    x2: 162.998,
    y1: 44.315,
    y2: 211.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser01Small);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-01-small.6c49333d21902b0e64930c535a4149b8.svg";
export { ForwardRef as ReactComponent };